import { Theme } from '@mui/material/styles'

// ----------------------------------------------------------------------

export default function Popover(theme: Theme) {
  return {
    MuiPopover: {
      styleOverrides: {
        root: {
          zIndex: 2000000001,
        },
        paper: {
          boxShadow: theme.shadows[8],
          borderRadius: Number(theme.shape.borderRadius) * 1.5,
        },
      },
    },
  }
}
